/* src/components/RecipientsEditor.jsx
 * Standalone notification-recipients chip editor.
 * Extracted from FormBuilder spam-settings tab.
 */

import React, { useState } from 'react';
import { useToast } from '../contexts/ToastContext';

export default function RecipientsEditor({ recipients = [], ownerEmail = '', onChange }) {
  const { showToast } = useToast();
  const [input, setInput] = useState('');

  function handleAdd() {
    const email = input.trim();
    if (!email) return;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showToast('Invalid email address', 'error');
      return;
    }
    if (recipients.includes(email)) {
      showToast('Email already added', 'error');
      return;
    }
    onChange([...recipients, email]);
    setInput('');
  }

  function handleRemove(idx) {
    onChange(recipients.filter((_, i) => i !== idx));
  }

  return (
    <div className="fb-callout info">
      <h4 className="fb-subheading">Notification recipients</h4>
      <p className="fb-muted" style={{ fontSize: '0.85rem', marginBottom: '1rem' }}>
        {ownerEmail ? (
          <>
            <strong>{ownerEmail}</strong> always gets the daily digest of every lead.
            Immediate alerts go to whoever the lead is assigned to — {ownerEmail} when
            no one is assigned. Extra addresses get the same immediate alerts; they do
            not replace the owner or the assignee.
          </>
        ) : (
          'The workspace owner always gets the daily digest of every lead. Immediate alerts go to whoever the lead is assigned to — the owner when no one is assigned. Extra addresses get the same immediate alerts; they do not replace the owner or the assignee.'
        )}
      </p>

      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.75rem', flexWrap: 'wrap' }}>
        <input
          type="email"
          className="fb-input"
          placeholder="teammate@example.com"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleAdd(); } }}
          style={{ flex: 1, minWidth: 200 }}
        />
        <button
          type="button"
          className="inbox-pill-btn-primary"
          onClick={handleAdd}
        >
          Add
        </button>
      </div>

      {recipients.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
          {recipients.map((email, i) => (
            <div key={i} className="inbox-chip accent-soft" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
              <span>{email}</span>
              <button
                type="button"
                onClick={() => handleRemove(i)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'var(--muted)',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                  lineHeight: 1,
                  padding: 0,
                }}
                title="Remove"
                aria-label={`Remove ${email}`}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
